<template>
<div class="grid justify-items-stretc">
    <div class="flex items-center justify-between pt-8 pb-4 px-6">
        <span class="flex items-center ">
            <MediaLogo class="mr-2"/>
            Media
        </span>
        <Arrow/>
    </div>
    <div class="m-6 p-6 bg-white rounded-lg">
        <div class=" border-gray-200 border-b-2 py-4 ">
            <h3 class=" text-payneFire font-semibold text-sm">URL</h3>
            <a :href="media" class=" text-carolina text-sm cursor-pointer">{{media}}</a>
        </div>
        <div class="flex items-center justify-between py-6">
            <span class=" text-payneFire font-semibold">Media files</span>
            <span class=" text-carolina font-semibold text-sm cursor-pointer">Download All</span>
        </div>
        <div :style="`background-image: url(${postType === 'image' ? media : ''})`" class="w-6/12 h-52 relative rounded-2xl bg-cover bg-center">

        <video v-if="postType === 'video'" autoplay muted loop id="myVideo" class="h-52 relative rounded-2xl bg-cover bg-center">
            <source :src="media" type="video/mp4">
        </video>

            <div v-show="!posted" class="flex justify-center items-center absolute -top-3 -right-3 bg-white rounded-full w-10 h-10 shadow-lg text-payneFire cursor-pointer"><XIcon/></div>
            <a :href="media" class="flex justify-center items-center absolute bottom-5 right-5 bg-white rounded-lg w-8 h-8 cursor-pointer"><DownloadIcon/></a>
        </div>
    </div>
    <button
        :disabled="posted"
        class="bg-platinumFire rounded-lg px-10 py-3 justify-self-end  text-sm text-cosmosHot border-2 border-gray-200 mr-6"
        type="button"
        ref="button"
    >Save</button>
</div>
  
</template>

<script>
import DownloadIcon from '@/components/svg/Download';
import XIcon from '@/components/svg/XIcon';
import MediaLogo from '@/components/svg/MediaLogo';

export default {
    name:"Media"  ,

    props: {
        media: {
            type: String,
            required: true
        },

        postType: {
            type: String,
            required: true
        },

        posted: {
            type: Boolean,
            required: true
        }
    },

    components: {
        DownloadIcon,
        XIcon,
        MediaLogo
        
    },
}
</script>